import { observer } from "mobx-react-lite";
import TicketStore from "core/stores/ticket.store";
import Pager from "components/pager";
import QueryDetailsRow from "./query-details-row";

type QueryListProps = {
    store: TicketStore,
    onSelectTicket: any
}

const QueriesList = observer((props: QueryListProps) => {
    const { store, onSelectTicket } = props;

    if (!store.hasTickets) {
        return null;
    }

    return (
        <>
            <ol className="info-rows">
                {
                    store.pageItems
                        .map((supportQuery, index) => {
                            return (
                                <QueryDetailsRow
                                    key={index}
                                    supportQuery={supportQuery}
                                    onClick={(e: any, id: string) => onSelectTicket(e, id)}
                                    clickable={true}
                                />
                            );
                        })}
            </ol>

            <Pager
                isLoading={store.isLoading}
                currentItems={store.pageItems}
                pageCount={store.numPages}
                currentPage={store.currentPage}
                handlePageClick={(e: any) => {
                    store.updateCurrentPage(e.selected);
                }} />
        </>
    );
});

export default QueriesList;
